import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError, api, drawErrorCode } from '~/lib/api';
import { AUTH_KEYS } from '~/hooks/use-auth';
import { LANDING_STATE_KEY } from '~/hooks/use-landing-state';
import type { LandingState } from '~shared/schemas';

/** Розыгрыш на лендинге (connect-landing-draw): открытие козочки и «Мои подарки». */

const AWARDS_KEY = ['landing', 'awards'] as const;

export function useLandingAwards(enabled: boolean) {
  return useQuery({ queryKey: AWARDS_KEY, queryFn: api.landing.awards, enabled, retry: false });
}

/**
 * Открытие козочки. Баланс — один на весь лендинг: ответ розыгрыша пишется в кэш состояния лендинга,
 * и шапка, первый экран, плавающая кнопка и поле обновляются вместе без лишнего запроса.
 */
export function useLandingDraw() {
  const qc = useQueryClient();
  const setBalance = (balance: number) =>
    qc.setQueryData<LandingState | null>(LANDING_STATE_KEY, (s) => (s ? { ...s, balance } : s));
  return useMutation({
    mutationFn: api.landing.draw,
    onSuccess: (result) => {
      setBalance(result.balance);
      void qc.invalidateQueries({ queryKey: AWARDS_KEY });
    },
    onError: (err) => {
      const code = drawErrorCode(err);
      if (code === 'NO_TICKETS') setBalance(0);
      else if (code === 'PARTICIPATION_NOT_CONFIRMED') void qc.invalidateQueries({ queryKey: LANDING_STATE_KEY });
      else if (code === 'NOT_ELIGIBLE' || (err instanceof ApiError && err.status === 401)) void qc.invalidateQueries({ queryKey: AUTH_KEYS.me });
    },
  });
}
